<!--
 * @Author: wh
 * @Date: 2020-07-01 17:05:02
 * @LastEditTime: 2020-09-08 14:25:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\orderSituation\orderlist.vue
-->
<template>
    <div class="orderSituationList">
        <van-nav-bar
            title="订单进度"
            left-text=""
            left-arrow
            @click-left="onClickLeft"
        ></van-nav-bar>
        <div class="search-con">
            <van-search
                placeholder="请输入搜索关键词"
                v-model="keywords"
                @search="handleSearch"
            ></van-search>
        </div>
        <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
            <template>
                <div class="warpper">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                    >
                        <div
                            class="materialPlan-item"
                            v-for="(item,index) in orderList"
                            :key="index"
                        >
                            <ul>
                                <li class="tit">
                                    <span class="iconfont icondanjubianhao"></span>
                                    <span class="info">订单编号：{{ item.order_number }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon materialPlan02"></span>
                                    <span class="info">客户名称：{{ item.customer_name }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon materialPlan01"></span>
                                    <span class="info">工程名称：{{ item.project_name }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon materialPlan02"></span>
                                    <span class="info">施工单位：{{ item.sgdw_name }}</span>
                                </li>
                                <li>
                                    <span class="pre-icon materialPlan03"></span>
                                    <span class="info">施工部位：{{ item.place_detail }}</span>
                                </li>
                                <li>
                                    <van-row>
                                        <van-col span="12">
                                            <span class="pre-icon materialPlan03"></span>
                                            <span class="info">供货站点：{{ item.station_name }}</span>
                                        </van-col>
                                        <van-col span="12">
                                            <span class="pre-icon materialPlan07"></span>
                                            <span class="info">强度等级：{{ item.strength_grade_name }}</span>
                                        </van-col>
                                    </van-row>
                                </li>
                                <li>
                                    <van-row>
                                        <van-col span="12">
                                            <span class="pre-icon materialPlan04"></span>
                                            <span class="info">计划方量：{{ item.quantity }}m³</span>
                                        </van-col>
                                        <van-col span="12">
                                            <span class="pre-icon materialPlan04"></span>
                                            <span class="info">发货方量：{{ item.grand_total_quantity }}m³</span>
                                        </van-col>
                                    </van-row>
                                </li>
                                <li>
                                    <van-row>
                                        <van-col span="12">
                                            <span class="pre-icon materialPlan05"></span>
                                            <span class="info">发货车次：{{ item.grand_total_vehicle }}次</span>
                                        </van-col>
                                        <van-col span="12">
                                            <span class="pre-icon materialPlan04"></span>
                                            <span class="info">签收方量：{{ item.sign_volume }}m³</span>
                                        </van-col>
                                    </van-row>
                                </li>
                                <li>
                                    <span class="pre-icon materialPlan06"></span>
                                    <span class="info">开始供应时间：{{ item.product_time||'未开始供应' }}</span>
                                </li>
                            </ul>
                            <div class="btn-con">
                                <div class="btn-item" @click="toTransOrder(item.order_number)">
                                    <span class="btn-span">查看明细</span>
                                </div>
                                <div class="btn-item" @click="toTransMap(item.order_number)">
                                    <span class="btn-span">发货进度</span>
                                </div>
                            </div>
                        </div>
                    </van-list>
                </div>
            </template>
        </van-pull-refresh>
        <!-- 加载层 -->
        <van-overlay :show="showOverlay">
            <van-loading type="spinner"></van-loading>
        </van-overlay>
    </div>
</template>
<script>
import BLL from './index';
export default {
    name: 'order-situation-list',
    components: {},
    beforeRouteLeave(to, from, next) {
        if (to.path === '/home') {
            this.keywords = '';
            this.$store.commit('noKeepAlive', 'order-situation-list');
        }
        next();
    },
    data() {
        return {
            orderList: [],
            loading: false,
            finished: false,
            page: {
                pageindex: 0,
                pagesize: 3,
            },
            total: true,
            cvid: '',
            // 下拉刷新
            isLoading: false,
            // 关键词
            keywords: '',
            // 加载层
            showOverlay: false,
            station_code: '',
            status: '',
        };
    },
    activated() {

    },
    created() {
        // this.page.pageindex = 1;
        // this.retailList = [];
        // this.finished = false;
        // this.showOverlay = true;
        // this.keywords = '';
        // 初始化
        this.BLL = new BLL(this);
        // this.orderListPage();
    },
    methods: {
        // 返回
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.replace({ path: '/home' });
            this.$router.go(-1);
        },
        // 查看明细
        toTransOrder(order_number) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'transOrderlist', params: { order_number: order_number } });
        },
        // 发货进度
        toTransMap(order_number) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'logisticsVehicleInfo', params: { order_number: order_number } });
        },
        // 下拉刷新
        onRefresh() {
            this.page.pageindex = 0;
            this.finished = false;
            this.loading = true;
            this.onLoad();
        },
        // 根据关键词搜索
        handleSearch() {
            this.page.pageindex = 1;
            this.orderList = [];
            this.finished = false;
            this.orderListPage();
        },
        // 分页拉取
        onLoad() {
            if (this.isLoading) {
                this.orderList = [];
                this.isLoading = false;
            }
            this.page.pageindex += 1;
            this.orderListPage();
        },
        // 订单进度分页
        async orderListPage() {
            const res = await this.BLL.getOrderList();
            if (res) {
                this.showOverlay = false;
                this.loading = false;
                this.isLoading = false;
                if (res.total) {
                    this.total = true;
                    this.orderList = this.orderList.concat(res.rows);
                    if (this.orderList.length >= res.total) {
                        this.finished = true;
                    }
                } else {
                    this.total = false;
                    this.finished = true;
                }
            }
        },
    },

};
</script>

<style lang="stylus">
@import './index.stylus';
</style>
<style>
    .retailAccountList .van-list__error-text, .van-list__finished-text, .van-list__loading{
        position: relative;
        height: 50rpx;
    }
    .retailAccountList .van-loading__spinner{
        position: relative!important;
        top: 0!important;
        left: 0!important;
        display: inline-block;
        width: 30px;
        max-width: 100%;
        height: 30px;
    }
</style>
